export default __webpack_public_path__ + "assets/f6bfb114a178475fb423de1a56b45b6f.svg";